<template>
  <section class="home-services mb-3 mb-md-5">
    <div class="container">
      <div class="service-head-wrapper">
        <div
          class="d-none d-md-flex justify-content-md-center sec-title-wrapper"
        >
          <h1 class="sec-title">Servicios</h1>
        </div>
        <div
          class="service-item d-flex justify-content-center"
          v-for="(service, index) in services"
          :key="index"
        >
          <div class="service-logo">
            <router-link :to="service.link">
              <img class="service-log-img img-fluid" :src="service.icon" alt />
            </router-link>
          </div>
          <div class="service-desc d-none d-md-block">
            <h3 class="service-title">{{ service.title }}</h3>
          </div>
        </div>
      </div>
      <div class="services-desc d-none d-md-block mb-3 mb-md-4">
        <h4>
          A través de nuestros servicios le ofrecemos seguridad y control de los
          <br />procesos a fin de contibuir en el éxito de la cadena de
          suministro
        </h4>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeServices',
  data() {
    return {
      services: [
        {
          title: 'Almacenaje',
          icon: require('@/assets/images/almacenaje.svg'),
          link: '/servicios#almacenaje',
        },
        {
          title: 'Logistica',
          icon: require('@/assets/images/logistica.svg'),
          link: '/servicios#logistica',
        },
        {
          title: 'Control de Inventarios',
          icon: require('@/assets/images/controldeinventarios.svg'),
          link: '/servicios#controldeinventarios',
        },
        {
          title: 'Servicios Preferentes',
          icon: require('@/assets/images/servicospreferentes.svg'),
          link: '/servicios#serviciospreferentes',
        },
        {
          title: 'Mejora de Inventarios',
          icon: require('@/assets/images/mejoradeproducto.svg'),
          link: '/servicios#mejoradeproducto',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.service-head-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  margin-bottom: 2.5rem;
  flex-wrap: wrap;
}
.sec-title-wrapper {
  width: 100%;
}
.service-log-img {
  max-width: 50px;
}
.service-title {
  line-height: 1.5rem;
}

@media screen and (min-width: 768px) {
  .service-head-wrapper {
    justify-content: space-between;
  }
  .sec-title-wrapper {
    align-self: center;

    margin-right: 2%;
  }
  .service-item {
    text-align: center;
    width: 16%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-right: 2%;
    &:last-child {
      margin-right: 0;
    }
  }
  .service-desc {
    h3 {
      font-size: 1.2rem;
      font-weight: 200;
    }
  }
  .services-desc {
    h4 {
      text-align: center;
    }
  }
  .service-log-img {
    max-width: 100px;
  }
}
@media screen and (min-width: 992px) {
  .service-head-wrapper {
    justify-content: space-between;
    flex-wrap: nowrap;
  }
  .sec-title-wrapper {
    width: initial;
  }
}
</style>
